var buffer = new ArrayBuffer(174);var uint8 = new Uint8Array(buffer);uint8.set([0,97,115,109,1,0,0,0,1,14,3,96,2,127,127,0,96,0,0,96,1,127,1,127,2,15,1,3,101,110,118,6,109,101,109,111,114,121,2,0,0,3,6,5,0,0,0,2,1,7,53,5,10,119,114,105,116,101,95,102,117,108,108,0,0,6,115,101,116,56,95,108,0,1,6,115,101,116,56,95,104,0,2,9,114,101,97,100,95,102,117,108,108,0,3,6,109,101,109,111,114,121,2,0,8,1,4,10,65,5,9,0,32,0,32,1,59,1,0,11,15,0,32,0,65,16,116,65,16,117,32,1,58,0,0,11,18,0,32,0,65,1,106,65,16,116,65,16,117,32,1,58,0,0,11,7,0,32,0,46,1,0,11,10,0,65,14,65,208,0,59,1,0,11,]);// This file will not run on it's own

const {
  Module,
  instantiate,
  Memory,
  Table
} = WebAssembly;

const WebAssemblyModule = function(deps = {
  'global': {},
  'env': {
    'memory': new Memory({initial: 10, limit: 100}),
    'table': new Table({initial: 0, element: 'anyfunc'})
  }
}) {
  return instantiate(buffer, deps);
}

module.exports = WebAssemblyModule;
